<template>
  <div class="report-apply-form">
    <el-form
      ref="formRef"
      :model="formData"
      :rules="rules"
      label-width="110px"
      size="small"
      class="workflow-form"
      :disabled="readonly || loading"
    >
      <div class="workflow-form-section">
        <div class="workflow-form-section__title">
          <i class="el-icon-s-order"></i>
          <span>申请基础信息</span>
        </div>
        <el-row :gutter="18">
          <el-col :span="24">
            <el-form-item label="销售订单号" prop="rfiOrderNum">
              <el-select v-model="formData.rfiOrderNum" filterable remote :remote-method="remoteSearchOrderNum" :loading="orderNumLoading" clearable placeholder="输入行程名称搜索订单号" style="width: 100%" @change="handleFieldChange('rfiOrderNum', $event)" @clear="remoteSearchOrderNum('')">
                <el-option v-for="item in orderNumOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户群体" prop="rrmaCustomer">
              <el-select v-model="formData.rrmaCustomer" clearable placeholder="请选择客户群体" style="width: 100%" @change="handleFieldChange('rrmaCustomer', $event)">
                <el-option v-for="item in customerOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="省份" prop="rrmaProvince">
              <el-select v-model="formData.rrmaProvince" clearable placeholder="请选择省份" style="width: 100%" :disabled="readonly || !formData.rrmaCustomer" @change="handleFieldChange('rrmaProvince', $event)">
                <el-option v-for="item in provinceOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地市" prop="rrmaCity">
              <el-select v-model="formData.rrmaCity" clearable placeholder="请选择地市" style="width: 100%" :disabled="readonly || !formData.rrmaProvince" @change="handleFieldChange('rrmaCity', $event)">
                <el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程类型" prop="rrmaCourseType">
              <el-select v-model="formData.rrmaCourseType" clearable placeholder="请选择课程类型" style="width: 100%" :disabled="readonly || !formData.rrmaCity" @change="handleFieldChange('rrmaCourseType', $event)">
                <el-option v-for="item in courseTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="包内含资料" prop="rrmaModelName">
              <el-select v-model="formData.rrmaModelName" clearable placeholder="请选择报告包资料" style="width: 100%" :disabled="readonly || !formData.rrmaCourseType" @change="handleFieldChange('rrmaModelName', $event)">
                <el-option v-for="item in modelNameOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="workflow-form-section">
        <div class="workflow-form-section__title">
          <i class="el-icon-document-copy"></i>
          <span>课程命名信息</span>
        </div>
        <el-row :gutter="18">
          <el-col :span="12">
            <el-form-item label="客户名称" prop="applyRuleNameCustomer">
              <el-input v-model="formData.applyRuleNameCustomer" clearable placeholder="请输入客户名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户简称" prop="applyRuleNameCustomerShort">
              <el-input v-model="formData.applyRuleNameCustomerShort" clearable placeholder="请输入客户简称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="课程名称" prop="applyRuleNameCourse">
              <el-input v-model="formData.applyRuleNameCourse" clearable placeholder="请输入课程名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开始日期" prop="applyRuleNameDateStart">
              <el-date-picker v-model="formData.applyRuleNameDateStart" type="date" value-format="yyyy-MM-dd" placeholder="请选择开始日期" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束日期" prop="applyRuleNameDateEnd">
              <el-date-picker v-model="formData.applyRuleNameDateEnd" type="date" value-format="yyyy-MM-dd" placeholder="请选择结束日期" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import {
  getRtReportModelListParamUser,
  getRtReportModelApplyDetailsUser,
  addRtReportModelApplyUser,
  updateRtReportModelApplyUser,
  getRtFxxkItineraryListApplyUsers,
  getRtReportModelParamUserInput
} from '@/api/api'

function toOptions (list) {
  return (list || []).map(item => ({ label: item, value: item }))
}

function toOrderNumOptions (list) {
  const seen = new Set()
  return (list || []).filter(item => {
    const orderNum = String(item.rfiOrderNum || '')
    if (!orderNum || seen.has(orderNum)) return false
    seen.add(orderNum)
    return true
  }).map(item => {
    const orderNum = String(item.rfiOrderNum || '')
    const customerName = item.rfiProjectCustomer || item.rfiProjectCustomerShort || '-'
    const projectName = item.rfiProjectName || orderNum
    return { label: `${projectName} / ${customerName} / ${orderNum}`, value: orderNum }
  })
}

function createEmptyFormData () {
  return {
    rrmaId: null,
    rfiOrderNum: '',
    rrmaCustomer: '',
    rrmaProvince: '',
    rrmaCity: '',
    rrmaCourseType: '',
    rrmaModelName: '',
    rrmaStatus: 1,
    applyRuleNameCustomer: '',
    applyRuleNameCustomerShort: '',
    applyRuleNameCourse: '',
    applyRuleNameDateStart: '',
    applyRuleNameDateEnd: ''
  }
}

export default {
  name: 'ReportApplyForm',
  props: {
    rrmaId: { type: [Number, String], default: null },
    readonly: { type: Boolean, default: false },
    detailData: { type: Object, default: null }
  },
  data () {
    return {
      loading: false,
      itineraryList: [],
      formData: createEmptyFormData(),
      orderNumOptions: [],
      orderNumLoading: false,
      customerOptions: [],
      provinceOptions: [],
      cityOptions: [],
      courseTypeOptions: [],
      modelNameOptions: [],
      optionCache: {},
      appliedDetailId: null,
      rules: {
        rrmaCustomer: [{ required: true, message: '客户群体不能为空', trigger: 'change' }],
        rrmaProvince: [{ required: true, message: '省份不能为空', trigger: 'change' }],
        rrmaCourseType: [{ required: true, message: '课程类型不能为空', trigger: 'change' }],
        rrmaModelName: [{ required: true, message: '包内含资料不能为空', trigger: 'change' }]
      }
    }
  },
  watch: {
    detailData: {
      immediate: true,
      handler (val) {
        if (val && String(val.rrmaId || '') !== String(this.appliedDetailId || '')) this.applyDetail(val)
      }
    },
    rrmaId: {
      immediate: true,
      handler (val) {
        if (val && !this.detailData) this.loadDetail(val)
      }
    }
  },
  created () {
    this.remoteSearchOrderNum('')
    this.loadCustomerOptions()
  },
  methods: {
    // 远程搜索订单号（输入行程名称关键词查询，空关键词加载默认列表）
    async remoteSearchOrderNum (query) {
      this.orderNumLoading = true
      try {
        const params = {}
        if (query && query.trim()) params.afiProjectName = query.trim()
        const res = await getRtFxxkItineraryListApplyUsers(params)
        this.itineraryList = res.data || []
        this.orderNumOptions = toOrderNumOptions(res.data)
      } catch (e) {
        this.itineraryList = []
        this.orderNumOptions = []
      } finally {
        this.orderNumLoading = false
      }
    },
    async loadCustomerOptions () {
      const options = await this.loadFormOptions(1)
      this.customerOptions = options
      if (!this.formData.rrmaCustomer) await this.autoCascade(this.customerOptions, 1)
    },
    async loadDetail (rrmaId) {
      this.loading = true
      try {
        const res = await getRtReportModelApplyDetailsUser({ rrmaId })
        const detail = res.data || null
        if (detail) {
          this.appliedDetailId = detail.rrmaId || rrmaId
          await this.applyDetail(detail)
          this.$emit('detail-loaded', detail)
        }
      } finally {
        this.loading = false
      }
    },
    async applyDetail (detail) {
      this.appliedDetailId = detail.rrmaId || this.appliedDetailId
      this.formData = {
        rrmaId: detail.rrmaId,
        rfiOrderNum: detail.rfiOrderNum || '',
        rrmaCustomer: detail.rrmaCustomer || '',
        rrmaProvince: detail.rrmaProvince || '',
        rrmaCity: detail.rrmaCity || '',
        rrmaCourseType: detail.rrmaCourseType || '',
        rrmaModelName: detail.rrmaModelName || '',
        rrmaStatus: detail.rrmaStatus || 1,
        applyRuleNameCustomer: detail.applyRuleNameCustomer || '',
        applyRuleNameCustomerShort: detail.applyRuleNameCustomerShort || '',
        applyRuleNameCourse: detail.applyRuleNameCourse || '',
        applyRuleNameDateStart: detail.applyRuleNameDateStart || '',
        applyRuleNameDateEnd: detail.applyRuleNameDateEnd || ''
      }
      await this.loadCascadeOptions(detail)
      // 编辑回填后也加载默认行程列表，方便用户更换订单号
      this.remoteSearchOrderNum('')
    },
    async loadCascadeOptions (detail) {
      await this.loadCustomerOptions()
      this.provinceOptions = detail.rrmaCustomer ? await this.loadFormOptions(2, detail.rrmaCustomer) : []
      this.cityOptions = detail.rrmaCustomer && detail.rrmaProvince ? await this.loadFormOptions(3, detail.rrmaCustomer, detail.rrmaProvince) : []
      this.courseTypeOptions = detail.rrmaCustomer && detail.rrmaProvince && detail.rrmaCity ? await this.loadFormOptions(4, detail.rrmaCustomer, detail.rrmaProvince, detail.rrmaCity) : []
      this.modelNameOptions = detail.rrmaCustomer && detail.rrmaProvince && detail.rrmaCity && detail.rrmaCourseType ? await this.loadFormOptions(5, detail.rrmaCustomer, detail.rrmaProvince, detail.rrmaCity, detail.rrmaCourseType) : []
    },
    async loadFormOptions (modelType, rrmCustomer, rrmProvince, rrmCity, rrmCourseType) {
      const params = { modelType }
      if (rrmCustomer) params.rrmCustomer = rrmCustomer
      if (rrmProvince) params.rrmProvince = rrmProvince
      if (rrmCity) params.rrmCity = rrmCity
      if (rrmCourseType) params.rrmCourseType = rrmCourseType
      const cacheKey = JSON.stringify(params)
      if (this.optionCache[cacheKey]) return this.optionCache[cacheKey]
      try {
        const res = await getRtReportModelListParamUser(params)
        const options = toOptions(res.data)
        this.$set(this.optionCache, cacheKey, options)
        return options
      } catch (e) {
        return []
      }
    },
    async autoCascade (currentOptions, currentModelType) {
      if (!currentOptions || currentOptions.length !== 1 || currentModelType > 5) return
      const value = currentOptions[0].value
      const propMap = { 1: 'rrmaCustomer', 2: 'rrmaProvince', 3: 'rrmaCity', 4: 'rrmaCourseType', 5: 'rrmaModelName' }
      const optionMap = { 2: 'provinceOptions', 3: 'cityOptions', 4: 'courseTypeOptions', 5: 'modelNameOptions' }
      const prop = propMap[currentModelType]
      if (!prop) return
      this.formData[prop] = value
      if (currentModelType >= 5) return
      for (let i = currentModelType + 1; i <= 5; i++) this.formData[propMap[i]] = ''
      const nextModelType = currentModelType + 1
      const nextOptions = await this.loadFormOptions(
        nextModelType,
        this.formData.rrmaCustomer,
        this.formData.rrmaProvince,
        this.formData.rrmaCity,
        this.formData.rrmaCourseType
      )
      this[optionMap[nextModelType]] = nextOptions
      for (let i = nextModelType + 1; i <= 5; i++) this[optionMap[i]] = []
      await this.autoCascade(nextOptions, nextModelType)
    },
    async handleFieldChange (prop, value) {
      if (prop === 'rfiOrderNum') {
        const selected = (this.itineraryList || []).find(item => String(item.rfiOrderNum || '') === String(value || ''))
        this.formData.rfiOrderNum = value ? String(value) : ''
        this.formData.applyRuleNameCustomer = selected ? (selected.rfiProjectCustomer || '') : ''
        this.formData.applyRuleNameCustomerShort = selected ? (selected.rfiProjectCustomerShort || '') : ''
        this.formData.applyRuleNameCourse = selected ? (selected.rfiCourseName || '') : ''
        this.formData.applyRuleNameDateStart = selected ? (selected.rfiCourseDateStart || '') : ''
        this.formData.applyRuleNameDateEnd = selected ? (selected.rfiCourseDateEnd || '') : ''
        // 选择订单号后，调用接口快速获取并直接回填五个级联字段
        if (value) {
          try {
            const res = await getRtReportModelParamUserInput({ rfiOrderNum: value })
            const data = res.data || {}
            if (data.rrmaCustomer) {
              this.formData.rrmaCustomer = data.rrmaCustomer
              this.provinceOptions = await this.loadFormOptions(2, data.rrmaCustomer)
            }
            if (data.rrmaProvince) {
              this.formData.rrmaProvince = data.rrmaProvince
              this.cityOptions = await this.loadFormOptions(3, data.rrmaCustomer, data.rrmaProvince)
            }
            if (data.rrmaCity) {
              this.formData.rrmaCity = data.rrmaCity
              this.courseTypeOptions = await this.loadFormOptions(4, data.rrmaCustomer, data.rrmaProvince, data.rrmaCity)
            }
            if (data.rrmaCourseType) {
              this.formData.rrmaCourseType = data.rrmaCourseType
              this.modelNameOptions = await this.loadFormOptions(5, data.rrmaCustomer, data.rrmaProvince, data.rrmaCity, data.rrmaCourseType)
            }
            if (data.rrmaModelName) {
              this.formData.rrmaModelName = data.rrmaModelName
            }
          } catch (e) {
            // 接口失败时静默处理，用户可手动选择
          }
        } else {
          // 清空订单号时重置级联字段
          this.formData.rrmaCustomer = ''
          this.formData.rrmaProvince = ''
          this.formData.rrmaCity = ''
          this.formData.rrmaCourseType = ''
          this.formData.rrmaModelName = ''
          this.provinceOptions = []
          this.cityOptions = []
          this.courseTypeOptions = []
          this.modelNameOptions = []
        }
        return
      }
      if (prop === 'rrmaCustomer') {
        this.formData.rrmaProvince = ''
        this.formData.rrmaCity = ''
        this.formData.rrmaCourseType = ''
        this.formData.rrmaModelName = ''
        this.provinceOptions = await this.loadFormOptions(2, value)
        this.cityOptions = []
        this.courseTypeOptions = []
        this.modelNameOptions = []
        await this.autoCascade(this.provinceOptions, 2)
      } else if (prop === 'rrmaProvince') {
        this.formData.rrmaCity = ''
        this.formData.rrmaCourseType = ''
        this.formData.rrmaModelName = ''
        this.cityOptions = await this.loadFormOptions(3, this.formData.rrmaCustomer, value)
        this.courseTypeOptions = []
        this.modelNameOptions = []
        await this.autoCascade(this.cityOptions, 3)
      } else if (prop === 'rrmaCity') {
        this.formData.rrmaCourseType = ''
        this.formData.rrmaModelName = ''
        this.courseTypeOptions = await this.loadFormOptions(4, this.formData.rrmaCustomer, this.formData.rrmaProvince, value)
        this.modelNameOptions = []
        await this.autoCascade(this.courseTypeOptions, 4)
      } else if (prop === 'rrmaCourseType') {
        this.formData.rrmaModelName = ''
        this.modelNameOptions = await this.loadFormOptions(5, this.formData.rrmaCustomer, this.formData.rrmaProvince, this.formData.rrmaCity, value)
        await this.autoCascade(this.modelNameOptions, 5)
      }
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.formRef.validate(valid => {
          if (valid) resolve(true)
          else reject(new Error('表单校验未通过'))
        })
      })
    },
    buildPayload (status) {
      return {
        rrmaId: this.formData.rrmaId,
        rfiOrderNum: this.formData.rfiOrderNum,
        rrmaCustomer: this.formData.rrmaCustomer,
        rrmaProvince: this.formData.rrmaProvince,
        rrmaCity: this.formData.rrmaCity,
        rrmaCourseType: this.formData.rrmaCourseType,
        rrmaModelName: this.formData.rrmaModelName,
        rrmaStatus: status,
        applyRuleNameCustomer: this.formData.applyRuleNameCustomer,
        applyRuleNameCustomerShort: this.formData.applyRuleNameCustomerShort,
        applyRuleNameCourse: this.formData.applyRuleNameCourse,
        applyRuleNameDateStart: this.formData.applyRuleNameDateStart,
        applyRuleNameDateEnd: this.formData.applyRuleNameDateEnd
      }
    },
    async persist (status) {
      await this.validate()
      this.loading = true
      try {
        const payload = this.buildPayload(status)
        let res
        if (payload.rrmaId) {
          res = await updateRtReportModelApplyUser(payload)
        } else {
          delete payload.rrmaId
          res = await addRtReportModelApplyUser(payload)
        }
        const saved = (res && res.data) || {}
        const nextDetail = { ...this.formData, ...saved, rrmaStatus: status, rrmaId: saved.rrmaId || this.formData.rrmaId }
        this.formData = nextDetail
        this.$emit(status === 1 ? 'saved' : 'submitted', nextDetail)
        this.$emit('status-change', nextDetail)
        return nextDetail
      } finally {
        this.loading = false
      }
    },
    saveDraft () {
      return this.persist(1)
    },
    submitApply () {
      return this.persist(2)
    }
  }
}
</script>

<style lang="scss" scoped>
.report-apply-form {
  width: 100%;
}

.workflow-form-section {
  padding: 20px 22px 8px;
  border: 1px solid rgba(203, 213, 225, 0.78);
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.92));

  & + & {
    margin-top: 16px;
  }
}

.workflow-form-section__title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  color: #0f172a;
  font-size: 16px;
  font-weight: 800;

  i {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border: 1px solid rgba(30, 64, 175, 0.16);
    border-radius: 12px;
    color: #1e40af;
    font-size: 18px;
    background: linear-gradient(180deg, #ffffff, #eef4ff);
    box-shadow: 0 8px 18px rgba(30, 64, 175, 0.12);
  }
}

::v-deep .workflow-form .el-row {
  display: flex;
  flex-wrap: wrap;
}

::v-deep .workflow-form .el-col {
  float: none;
}

::v-deep .workflow-form .el-form-item,
::v-deep .workflow-form .el-form-item.is-required,
::v-deep .workflow-form .el-form-item.is-success {
  margin-bottom: 18px;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}

::v-deep .workflow-form .el-form-item__label,
::v-deep .workflow-form .el-form-item.is-required .el-form-item__label,
::v-deep .workflow-form .el-form-item.is-success .el-form-item__label {
  padding: 0 12px 0 0;
  color: #334155 !important;
  font-size: 13px;
  font-weight: 800;
  line-height: 38px;
  text-align: right;
  white-space: nowrap;
  background: transparent !important;
  background-image: none !important;
  border: 0 !important;
  box-shadow: none !important;
}

::v-deep .workflow-form .el-form-item__label::before,
::v-deep .workflow-form .el-form-item__label::after {
  background: transparent !important;
  box-shadow: none !important;
}

::v-deep .workflow-form .el-form-item__content {
  line-height: 38px;
  background: transparent !important;
}

::v-deep .workflow-form .el-input,
::v-deep .workflow-form .el-select,
::v-deep .workflow-form .el-date-editor,
::v-deep .workflow-form .el-input__inner,
::v-deep .workflow-form .el-form-item.is-success .el-input__inner {
  height: 38px;
  line-height: 38px;
  background: #ffffff !important;
  background-image: none !important;
}
</style>
